<template>
  <iframe
    :src="url"
    width="600"
    height="450"
    class="shadow-xl border border-gray-200"
    allowfullscreen=""
    loading="lazy"
    v-bind="$attrs"
  ></iframe>
</template>

<script>
import { ref } from "vue";

export default {
  setup(props) {
    let key = "AIzaSyCTktY_7f5aCgUD0iJgIeJjoOcF2ew4xxs";
    let address = encodeURIComponent(props.address);
    const url = ref(
      "https://www.google.com/maps/embed/v1/place?key=" + key + "&q=" + address
    );

    return {
      url
    };
  },

  props: {
    address: {
      required: true,
      type: String
    }
  }
};
</script>
